import { ComponentIds, } from "@inter-ikea-core/core";
import BlockConnectionHoleComponent from "../components/BlockConnectionHoleComponent";
import { COMPONENT_IDS } from "../storage2ComponentIDs";
import { getEntityHolesOccupied } from "../utils/entityUtils";
/**
 * Get a list of all the connections an entity has
 * @param entity
 * @returns
 */
export const getEntityGuestConnections = (entity) => {
    var _a;
    const entityConnections = (_a = entity.getComponent(ComponentIds.GUEST_CONNECTIONS_COMPONENT_ID)) === null || _a === void 0 ? void 0 : _a.connections;
    if (!entityConnections)
        throw new Error("Entity is missing guest connections");
    return entityConnections;
};
/**
 * Get which hole an entity is attached to
 * @param entityConnections
 * @returns
 */
export const getEntityHole = (entityConnections) => {
    const insertConnectorConnection = entityConnections.find((connection) => connection.hostConnector.key.includes("insert-connector"));
    if (!insertConnectorConnection)
        throw new Error("No insert-connector connection");
    return insertConnectorConnection.hostConnector
        .hole;
};
/**
 * Get the existing BlockConnectionHoleComponent
 * @param entity
 * @returns
 */
export const getEntityBlockConnectionHoleComponent = (entity) => {
    const blockConnectionHoleComponent = entity.getComponent(COMPONENT_IDS.BLOCK_CONNECTION_HOLE_COMPONENT);
    return blockConnectionHoleComponent;
};
/**
 * Checks if any GuestConnectionsComponent includes the "to-section" key
 * @param entityConnections
 * @returns
 */
const checkGuestConnectorKey = (entityConnections) => entityConnections.find((connector) => connector.guestConnector.key.includes("to-section"));
/**
 * If the entity should cover any extra holes, this function will return a list of holes that should be blocked
 * @param entity
 * @param entityConnectionHole
 * @param blockConnectionHoleComponent
 * @returns
 */
const setConnectionHolesToBlock = (entity, entityConnectionHole, blockConnectionHoleComponent) => {
    // The minus 1 is needed to offset which connection holes are actaully covered by the entity
    const entityConnectionHolesOccupied = getEntityHolesOccupied(entity) - 1;
    const blockedHoles = [];
    blockedHoles.push(entityConnectionHole + blockConnectionHoleComponent.blockHoleAbove);
    blockedHoles.push(entityConnectionHole -
        entityConnectionHolesOccupied -
        blockConnectionHoleComponent.blockHoleBelow);
    return blockedHoles;
};
/**
 * This will update the BlockConnectionHoleComponent
 * @param entity
 */
export const updateBlockedHoles = (entity) => {
    const entityGuestConnections = getEntityGuestConnections(entity);
    if (!checkGuestConnectorKey(entityGuestConnections))
        return null;
    const entityConnectionHole = getEntityHole(entityGuestConnections);
    const blockConnectionHoleComponent = getEntityBlockConnectionHoleComponent(entity);
    if (!blockConnectionHoleComponent)
        return null;
    entity.removeComponent(COMPONENT_IDS.BLOCK_CONNECTION_HOLE_COMPONENT);
    entity.addComponent(new BlockConnectionHoleComponent({
        blockHoleAbove: blockConnectionHoleComponent.blockHoleAbove,
        blockHoleBelow: blockConnectionHoleComponent.blockHoleBelow,
        blockedHoles: setConnectionHolesToBlock(entity, entityConnectionHole, blockConnectionHoleComponent),
    }));
};
